import { PageHeader } from '@flos/react-ui';

const personDataURL =
    'https://www.topdanmark.dk/saadan-anvender-vi-data/?utm_medium=shorturl&utm_source=speak&utm_campaign=service_saadan_anvender_vi_data';

// This receipt page is only shown after the user has submitted a claim form on the OPEN pages (WWW forms).
// For Mit forms (forms behind login), a receipt page from the BloomReach CMS is used instead.
const ReceiptPage = () => {
    return (
        <div className="receipt-page">
            <PageHeader title="">
                <h1>Tak for din anmeldelse</h1>
            </PageHeader>
            <div className="container">
                <h3>Du behøver ikke at gøre mere</h3>
                <ul>
                    <li>Vi har sendt en kvittering på din mail</li>
                    <li>Hvis vi har brug for flere oplysninger, kontakter vi dig</li>
                    <li>Du kan se og følge din skade i Mit Topdanmark</li>
                </ul>
            </div>

            <div className="sub-container">
                <p>
                    Læs, hvordan vi passer på dine personoplysninger, i vores 
                    <a href={personDataURL}>persondatapolitik.</a>
                </p>
            </div>
        </div>
    );
};

export default ReceiptPage;
